module.exports = __webpack_public_path__ + "img/default_jp.6c1c9a2.jpg";